import { render } from "./AboutService.vue?vue&type=template&id=651a6240&scoped=true"
const script = {}

import "./AboutService.vue?vue&type=style&index=0&id=651a6240&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651a6240"]])

export default __exports__